export default __webpack_public_path__ + "static/media/trashOutlined.b64c166c.svg";